/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1SerieSerieidLangsIdMutationResponse,
  DeleteApiV1SerieSerieidLangsIdPathParams,
  DeleteApiV1SerieSerieidLangsId401,
  DeleteApiV1SerieSerieidLangsId404,
  DeleteApiV1SerieSerieidLangsId500,
} from "../../types/serieIdiomasController/DeleteApiV1SerieSerieidLangsId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1SerieSerieidLangsId } from "../../clients/serieIdiomasController/deleteApiV1SerieSerieidLangsId.ts";

export const deleteApiV1SerieSerieidLangsIdMutationKey = () =>
  [{ url: "/api/v1/serie/:serieId/langs/:id" }] as const;

export type DeleteApiV1SerieSerieidLangsIdMutationKey = ReturnType<
  typeof deleteApiV1SerieSerieidLangsIdMutationKey
>;

export function deleteApiV1SerieSerieidLangsIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteApiV1SerieSerieidLangsIdMutationKey();
  return mutationOptions<
    DeleteApiV1SerieSerieidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerieSerieidLangsId401
      | DeleteApiV1SerieSerieidLangsId404
      | DeleteApiV1SerieSerieidLangsId500
    >,
    {
      serieId: DeleteApiV1SerieSerieidLangsIdPathParams["serieId"];
      id: DeleteApiV1SerieSerieidLangsIdPathParams["id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ serieId, id }) => {
      return deleteApiV1SerieSerieidLangsId(serieId, id, config);
    },
  });
}

/**
 * @description Remove uma tradução (idioma) da série. **(Requer Authorization para autenticação)**
 * @summary Excluir idioma da série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs/:id}
 */
export function useDeleteApiV1SerieSerieidLangsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1SerieSerieidLangsIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1SerieSerieidLangsId401
        | DeleteApiV1SerieSerieidLangsId404
        | DeleteApiV1SerieSerieidLangsId500
      >,
      {
        serieId: DeleteApiV1SerieSerieidLangsIdPathParams["serieId"];
        id: DeleteApiV1SerieSerieidLangsIdPathParams["id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiV1SerieSerieidLangsIdMutationKey();

  const baseOptions = deleteApiV1SerieSerieidLangsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1SerieSerieidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerieSerieidLangsId401
      | DeleteApiV1SerieSerieidLangsId404
      | DeleteApiV1SerieSerieidLangsId500
    >,
    {
      serieId: DeleteApiV1SerieSerieidLangsIdPathParams["serieId"];
      id: DeleteApiV1SerieSerieidLangsIdPathParams["id"];
    },
    TContext
  >;

  return useMutation<
    DeleteApiV1SerieSerieidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerieSerieidLangsId401
      | DeleteApiV1SerieSerieidLangsId404
      | DeleteApiV1SerieSerieidLangsId500
    >,
    {
      serieId: DeleteApiV1SerieSerieidLangsIdPathParams["serieId"];
      id: DeleteApiV1SerieSerieidLangsIdPathParams["id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1SerieSerieidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerieSerieidLangsId401
      | DeleteApiV1SerieSerieidLangsId404
      | DeleteApiV1SerieSerieidLangsId500
    >,
    {
      serieId: DeleteApiV1SerieSerieidLangsIdPathParams["serieId"];
      id: DeleteApiV1SerieSerieidLangsIdPathParams["id"];
    },
    TContext
  >;
}
